import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Typography } from '@mui/material';
import { LoadingScreen } from '../common/LoadingScreen';

/**
 * Handles the Auth0 callback redirect and navigates to the home page
 * This component is rendered when users return from Auth0 authentication
 */
export const CallbackHandler: React.FC = () => {
  const { error } = useAuth0();

  // The Auth0ProviderWithNavigate component handles the redirect
  // This component just needs to show loading/error states

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <Typography variant="h6" color="error">
          Authentication Error
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {error.message}
        </Typography>
      </Box>
    );
  }

  return <LoadingScreen message="Authenticating..." />;
};